import Vue from 'vue'
import Store from '../store'
import VueRouter from 'vue-router'
import DefaultLayout from '../components/layouts/DefaultLayout'
import qs from 'qs'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import RouteNames from '@/constants/RouteNames'
import { ADMIN_URI_BASE, CUSTOMER_URI_BASE } from '@/constants/RouteNames'
import AuthRoles from '@/constants/AuthRoles'
import AllModels from '@/models/'

Vue.use(VueRouter)

let routes

routes = [
  {
    path: '/',
    name: RouteNames.Guest.HOME,
    component: () =>
      import(/* webpackChunkName: "Home" */ '../views/HomeView.vue'),
  },
  {
    path: '/menu',
    name: RouteNames.Guest.MENU,
    component: () =>
      import(/* webpackChunkName: "Menu" */ '../views/MenuView.vue'),
  },
  {
    path: '/about',
    name: RouteNames.Guest.ABOUT,
    component: () =>
      import(/* webpackChunkName: "AboutView" */ '../views/AboutView.vue'),
  },
  {
    path: '/help',
    name: RouteNames.Guest.HELP,
    component: () =>
      import(/* webpackChunkName: "Help" */ '../views/HelpView.vue'),
  },
  {
    path: '/feedback',
    name: RouteNames.Guest.FEEDBACK,
    component: () =>
      import(/* webpackChunkName: "Feedback" */ '../views/FeedbackView.vue'),
  },
  {
    path: '/maintenance',
    name: RouteNames.Guest.MAINTENANCE,
    component: () =>
      import(
        /* webpackChunkName: "MaintenanceMode" */ '../views/MaintenanceModeView.vue'
      ),
  },
  {
    path: '/expired',
    name: RouteNames.Guest.EXPIRED,
    component: () =>
      import(/* webpackChunkName: "Expired" */ '../views/ExpiredView.vue'),
  },
  {
    path: '/email/verify/success',
    name: RouteNames.Guest.VERIFY_EMAIL_SUCCESS,
    component: () =>
      import(
        /* webpackChunkName: "EmailVerificationSuccess" */ '../views/EmailVerificationSuccessView.vue'
      ),
  },
  {
    path: '/email/verify/expired',
    name: RouteNames.Guest.VERIFY_EMAIL_EXPIRED,
    component: () =>
      import(
        /* webpackChunkName: "EmailVerificationExpired" */ '../views/EmailVerificationExpiredView.vue'
      ),
  },
  {
    path: '/signup',
    name: RouteNames.Customer.SIGNUP,
    component: () =>
      import(
        /* webpackChunkName: "CustomerSignupView" */ '../views/CustomerSignupView.vue'
      ),
  },
  {
    path: '/login',
    name: RouteNames.Customer.LOGIN,
    component: () =>
      import(
        /* webpackChunkName: "CustomerLoginView" */ '../views/CustomerLoginView.vue'
      ),
  },
  {
    path: '/login/phone',
    name: RouteNames.Customer.LOGIN_WITH_PHONE,
    component: () =>
      import(
        /* webpackChunkName: "CustomerLoginPhoneView" */ '../views/CustomerLoginPhoneView.vue'
      ),
  },
  {
    path: '/login/forgot-password',
    name: RouteNames.Customer.FORGOT_PASSWORD,
    component: () =>
      import(
        /* webpackChunkName: "ForgotPasswordView" */ '../views/ForgotPasswordView.vue'
      ),
  },
  {
    path: '/login/merchant/forgot-email',
    name: RouteNames.Merchant.FORGOT_EMAIL,
    component: () =>
      import(
        /* webpackChunkName: "ForgotEmailView" */ '../views/ForgotEmailView.vue'
      ),
  },
  {
    path: '/login/password-reset/:token',
    name: RouteNames.Customer.PASSWORD_RESET,
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "PasswordResetView" */ '../views/PasswordResetView.vue'
      ),
  },
  {
    path: '/login/verify-phone/:phone',
    name: RouteNames.Customer.LOGIN_VERIFY_PHONE,
    component: () =>
      import(
        /* webpackChunkName: "LoginVerifyPhone" */ '../views/LoginVerifyPhoneView.vue'
      ),
  },
  {
    path: '/login/email/:emailHint',
    name: RouteNames.Customer.LOGIN_EMAIL_HINT,
    component: () =>
      import(
        /* webpackChunkName: "LoginEmail" */ '../views/LoginEmailView.vue'
      ),
  },
  {
    path: '/login/update/:phone/:emailHint',
    name: RouteNames.Customer.LEGACY_UPDATE,
    component: () =>
      import(
        /* webpackChunkName: "LegacyAccountUpdate" */ '../views/LegacyAccountUpdateView.vue'
      ),
  },
  {
    path: '/login/update/:phone/',
    name: RouteNames.Customer.LEGACY_UPDATE_NO_EMAIL,
    component: () =>
      import(
        /* webpackChunkName: "LegacyAccountUpdateNoEmail" */ '../views/LegacyAccountUpdateNoEmailView.vue'
      ),
  },
  {
    path: `/${CUSTOMER_URI_BASE}`,
    name: RouteNames.Customer.DASHBOARD,
    component: () =>
      import(
        /* webpackChunkName: "CustomerDashLayout" */ '../components/layouts/CustomerDashLayout.vue'
      ),
    children: [
      {
        path: 'edit',
        name: RouteNames.Customer.ACCOUNT_UPDATE,
        component: () =>
          import(
            /* webpackChunkName: "CustomerEdit" */ '../views/CustomerEditView.vue'
          ),
        meta: { auth: AuthRoles.CUSTOMER },
      },
      {
        path: 'orders',
        name: RouteNames.Customer.ORDERS_INDEX,
        component: () =>
          import(
            /* webpackChunkName: "OrderHistory" */ '../views/OrderHistoryView.vue'
          ),
        meta: { auth: AuthRoles.CUSTOMER },
      },
      {
        path: 'orders/:orderId',
        name: RouteNames.Customer.ORDER_VIEW,
        component: () =>
          import(/* webpackChunkName: "Invoice" */ '../views/InvoiceView.vue'),
        meta: { auth: AuthRoles.CUSTOMER },
        props: (route) => ({
          orderId: route.params.orderId,
        }),
      },
    ],
  },
  {
    path: '/order',
    name: RouteNames.Guest.NEW_ORDER,
    component: () =>
      import(/* webpackChunkName: "NewOrder" */ '../views/NewOrderView.vue'),
  },
  {
    path: '/email/verify/',
    name: RouteNames.Customer.VERIFY_EMAIL,
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "EmailVerificationView" */ '../views/EmailVerificationView.vue'
      ),
    meta: { auth: AuthRoles.CUSTOMER },
  },
  {
    path: `/owner/login`,
    name: RouteNames.Merchant.LOGIN,
    component: () =>
      import(
        /* webpackChunkName: "AdminLogin" */ '../views/MerchantLoginView.vue'
      ),
  },
  {
    path: `/owner/signup`,
    name: RouteNames.Merchant.SIGNUP,
    component: () =>
      import(
        /* webpackChunkName: "AdminSignup" */ '../views/AdminSignupView.vue'
      ),
  },
  {
    path: '/settings',
    redirect: `/${ADMIN_URI_BASE}`,
  },
  {
    path: `/${ADMIN_URI_BASE}`,
    redirect: `/${ADMIN_URI_BASE}/dashboard`,
    name: RouteNames.Merchant.Manage.HOME,
    component: () =>
      import(
        /* webpackChunkName: "AdminLayout" */ '../components/layouts/AdminLayout.vue'
      ),
    children: [
      {
        path: 'dashboard',
        name: RouteNames.Merchant.Manage.DASHBOARD,
        component: () =>
          import(
            /* webpackChunkName: "MerchantDashboard" */ '../components/MerchantDashboard.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
      },
      {
        path: 'shop',
        name: RouteNames.Merchant.Manage.SHOP_SETTINGS,
        component: () =>
          import(
            /* webpackChunkName: "ManageShopSettings" */ '../components/ManageShopSettings.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
      },
      {
        path: 'orders/prep',
        name: RouteNames.Merchant.Manage.ORDER_PREP,
        component: () =>
          import(
            /* webpackChunkName: "ManageOrderPrepView" */ '../views/cms/ManageOrderPrepView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
      },
      {
        path: 'orders/:id?',
        name: RouteNames.Merchant.Manage.ORDERS,
        component: () =>
          import(
            /* webpackChunkName: "ManageIndexView" */ '../views/cms/ManageIndexView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.OrderModel,
          id: route.params.id,
        }),
      },

      {
        path: 'sections/:id?',
        name: RouteNames.Merchant.Manage.SECTIONS,
        component: () =>
          import(
            /* webpackChunkName: "ManageIndexView" */ '../views/cms/ManageIndexView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.SectionModel,
          id: route.params.id,
        }),
      },
      {
        path: 'items/:id?',
        name: RouteNames.Merchant.Manage.ITEMS,
        component: () =>
          import(
            /* webpackChunkName: "ManageIndexView" */ '../views/cms/ManageIndexView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.ItemModel,
          id: route.params.id,
        }),
      },
      {
        path: 'rearrange-menu',
        name: RouteNames.Merchant.Manage.REARRANGE,
        component: () =>
          import(
            /* webpackChunkName: "ManageMenuOrderView" */ '../views/cms/ManageMenuOrderView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: {
          Model: AllModels.ItemModel,
        },
      },
      {
        path: 'availabilities/:id?',
        name: RouteNames.Merchant.Manage.AVAILABILITY,
        component: () =>
          import(
            /* webpackChunkName: "ManageIndexView" */ '../views/cms/ManageIndexView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.AvailabilityModel,
          id: route.params.id,
        }),
      },
      {
        path: 'customers/:id?',
        name: RouteNames.Merchant.Manage.CUSTOMERS,
        component: () =>
          import(
            /* webpackChunkName: "ManageIndexView" */ '../views/cms/ManageIndexView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.CustomerModel,
          id: route.params.id,
        }),
      },
      {
        path: 'account',
        name: RouteNames.Merchant.Manage.ACCOUNT,
        component: () =>
          import(
            /* webpackChunkName: "ManageAccount" */ '../components/ManageAccount.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
      },
      {
        path: 'support',
        name: RouteNames.Merchant.Manage.SUPPORT,
        component: () =>
          import(
            /* webpackChunkName: "MerchantSupport" */ '../views/cms/MerchantSupportView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
      },
      {
        path: 'super/dashboard',
        name: RouteNames.SuperAdmin.DASHBOARD,
        component: () =>
          import(
            /* webpackChunkName: "SuperAdminDashboard" */ '../components/SuperAdminDashboard.vue'
          ),
        meta: { auth: AuthRoles.SUPER_ADMIN },
      },
    ],
  },
  {
    path: `/${ADMIN_URI_BASE}/orders/print`,
    component: () =>
      import(
        /* webpackChunkName: "PrintLayout" */ '../components/layouts/PrintLayout.vue'
      ),
    children: [
      {
        path: ':id',
        name: RouteNames.Merchant.Manage.PRINT_ORDER,
        component: () =>
          import(
            /* webpackChunkName: "PrintOrderView" */ '../views/cms/PrintOrderView.vue'
          ),
        meta: { auth: AuthRoles.MERCHANT },
        props: (route) => ({
          Model: AllModels.OrderModel,
          id: route.params.id,
        }),
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
]

// Add default layout to any routes that don't have it set in the props already
routes = routes.map((rte) => {
  let layout = _get(rte, 'meta.layout', DefaultLayout)
  let meta = { ...rte.meta, layout }
  return { ...rte, meta }
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query)
  },
  stringifyQuery(query) {
    var result = qs.stringify(query)

    return result ? '?' + result : ''
  },
})

router.beforeEach(async (to, from, next) => {
  const hasFetchError = await Store.getters['shop/getShopFetchError']
  if (hasFetchError) {
    return false
  }
  await Store.dispatch('shop/fetchShop')
  const isAuthenticated = await Store.getters['auth/isAuthenticated']
  const isAdminAuthRoute = _includes(to.path.split('/'), ADMIN_URI_BASE)
  const isCustomerRoute = _get(to, 'meta.auth', false) === AuthRoles.CUSTOMER
  const isCartPage = to.name === RouteNames.Guest.NEW_ORDER

  const authRedirectRoute = await checkAuthRedirect(to)
  const willRedirectToExpiredPage = await shouldRedirectToExpiredPage(to.name)
  const willRedirectToMaintenancePage = await shouldRedirectToMaintenancePage(
    to.name
  )
  const isAboutPageDisabled = !Store.getters['shop/getBooleanToggle'](
    'Enable About Page'
  )
  if (authRedirectRoute) {
    // @TODO (ESS): resolve this using next()
    if (to.name === RouteNames.Customer.VERIFY_EMAIL) {
      router.push({
        name: authRedirectRoute,
        query: { ...to.query, verifyEmailPath: to.path },
      })
    } else {
      router.push({ name: authRedirectRoute, query: { next: to.name } })
    }
  } else if (willRedirectToExpiredPage) {
    next({ name: RouteNames.Guest.EXPIRED })
  } else if (willRedirectToMaintenancePage) {
    next({ name: RouteNames.Guest.MAINTENANCE })
  } else if (to.name === RouteNames.Guest.ABOUT && isAboutPageDisabled) {
    next({ name: RouteNames.Guest.HOME })
  } else if (isAdminAuthRoute && !isAuthenticated) {
    next({ name: RouteNames.Merchant.LOGIN, query: { loginRoute: to.name } })
  } else if (isAdminAuthRoute && isAuthenticated) {
    if (await Store.dispatch('auth/validateSession')) {
      next()
    } else {
      // @TODO (ESS): resolve this using next()
      router.push({
        name: RouteNames.Merchant.LOGIN,
        query: { loginRoute: to.name, loggedOut: true },
      })
    }
  } else if ((isCustomerRoute || isCartPage) && isAuthenticated) {
    if (await Store.dispatch('auth/validateSession')) {
      await maybeFetchShopCustomerData()
      const VerifyEmailRoute = RouteNames.Customer.VERIFY_EMAIL
      const isUserEmailVerified = await Store.getters[
        'auth/isAuthUserEmailVerified'
      ]
      // If user is not verified and
      // we're going anywhere *other* than the verification route
      if (!isUserEmailVerified && to.name !== VerifyEmailRoute) {
        // @TODO (ESS): resolve this using next()
        router.push({ name: VerifyEmailRoute })
      } else {
        next()
      }
    } else {
      // @TODO (ESS): resolve this using next()
      router.push({
        name: RouteNames.Customer.LOGIN,
        query: { loginRoute: to.name, loggedOut: true },
      })
    }
  } else if (isCartPage && !isAuthenticated) {
    // @TODO (ESS): resolve this using next()
    router.push({
      name: RouteNames.Customer.LOGIN,
      query: { next: to.name },
    })
  } else {
    next()
  }
})

const shouldRedirectToMaintenancePage = async (routeName) => {
  const isInMaintenanceMode = await Store.getters['shop/getIsMaintenanceModeOn']
  const isAuthenticated = await Store.getters['auth/isAuthenticated']

  const isRouteAllowedInMaintenance = _includes(
    [
      'Maintenance',
      RouteNames.Merchant.LOGIN,
      RouteNames.Merchant.FORGOT_EMAIL,
      RouteNames.Customer.FORGOT_PASSWORD,
      RouteNames.Customer.PASSWORD_RESET,
      RouteNames.Merchant.SHOP_SETTINGS,
      'Feedback',
    ],
    routeName
  )
  return !isRouteAllowedInMaintenance && isInMaintenanceMode && !isAuthenticated
}
const shouldRedirectToExpiredPage = async (routeName) => {
  const isShopDead = await Store.getters['shop/getIsShopDead']
  const isRouteAllowedWhenExpired = _includes(
    [
      RouteNames.Guest.EXPIRED,
      RouteNames.Merchant.LOGIN,
      RouteNames.Merchant.FORGOT_EMAIL,
      RouteNames.Customer.FORGOT_PASSWORD,
      RouteNames.Customer.PASSWORD_RESET,
      RouteNames.Merchant.Manage.SHOP_SETTINGS,
      RouteNames.Merchant.Manage.ACCOUNT,
    ],
    routeName
  )

  return !isRouteAllowedWhenExpired && isShopDead
}

const checkAuthRedirect = async (to) => {
  let authRequirement = _get(to, 'meta.auth', false)
  if (!authRequirement) {
    return false
  }
  const userRoles = await Store.getters['auth/userRoles']
  if (userRoles.is_super_admin) return false

  let redirect = false
  switch (authRequirement) {
    case AuthRoles.MERCHANT:
      redirect = userRoles.is_merchant ? false : RouteNames.Merchant.LOGIN
      break
    case AuthRoles.CUSTOMER:
      redirect = userRoles.is_customer ? false : RouteNames.Customer.LOGIN
      break
    default:
      break
  }

  return redirect
}

const maybeFetchShopCustomerData = async () => {
  // check for ShopCustomer data state
  const shopId = Store.getters['shop/getShopId']
  const authUser = Store.getters['auth/getAuthUser']
  const canMerchant = Store.getters['auth/canMerchant']
  if (
    !authUser ||
    canMerchant ||
    _get(authUser, 'loadedCustomerShopDataForId') === shopId
  ) {
    return Promise.resolve()
  } else {
    try {
      // await Store.dispatch( 'auth/fetchShopCustomerData', { customerId: authUser.id }, { root: true } )
      let { entities } = await AllModels.CustomerModel.fetchShopCustomerData(
        authUser.id
      )
      let user = entities.customers[0]
      Store.dispatch('auth/setUser', user, { root: true })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default router
